import type { ActionLevel } from '../types/anna';

export const actionLevels: {
  id: ActionLevel;
  label: string;
  rule: string;
  examples: string;
  control: string;
}[] = [
  {
    id: 'zelf',
    label: 'Niveau 1 · Zelf',
    rule: 'Anna deed het zelf. Achteraf gelogd.',
    examples: 'Licht, koffie, mails sorteren, concepten maken',
    control: 'Geen knop. Zichtbaar in het logboek.',
  },
  {
    id: 'tenzijBezwaar',
    label: 'Niveau 2 · Tenzij bezwaar',
    rule: 'Alleen omkeerbare huisacties. Aangekondigd; loopt na een zichtbare aftelling van 60 seconden, tenzij jij op Stop tikt.',
    examples: 'Verwarming lager, rolluiken, ventilatie',
    control: 'Aftelring van 60 s met grote Stop-knop',
  },
  {
    id: 'naOk',
    label: 'Niveau 3 · Na jouw ok',
    rule: 'Vraagt expliciete goedkeuring.',
    examples: 'Mail versturen, posten op Slack, code mergen, afspraken met anderen, boekingen, bestellingen',
    control: 'Schuif om te bevestigen',
  },
  {
    id: 'nooit',
    label: 'Nooit automatisch',
    rule: 'Sloten, alarm, betalingen, verwijderen. Nooit met een goedkeurknop of aftelling.',
    examples: 'Voordeur, alarm, betalingen, iets verwijderen',
    control: 'Alleen informatie: "Open zelf via …"',
  },
];
